import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/features/auth';

export const useRoute = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const baseURI = `/dashboard/${user?.signedInMethod}`;

  const routeToHome = () => {
    navigate(baseURI);
  };

  const routeToAnalysisHistory = () => {
    navigate(`${baseURI}/measurements`);
  };

  const routeToFermentationTracking = () => {
    navigate(`${baseURI}/fermentations`);
  };

  const routeToAnalysis = (batchId: string) => {
    navigate(`${baseURI}/measurements/${batchId}`);
  };

  const routeToFermentation = (fermentationId: string) => {
    navigate(`${baseURI}/fermentations/${fermentationId}`);
  };

  const routeToFermentationBatch = ({
    batchId,
    fermentationId,
  }: {
    batchId: string;
    fermentationId: string;
  }) => {
    navigate(`${baseURI}/fermentations/${fermentationId}/batch/${batchId}`);
  };

  const routeToPitchCalculator = (batchId: string) => {
    navigate(`${baseURI}/measurements/${batchId}/pitch-calculator`);
  };

  return {
    routeToHome,
    routeToAnalysis,
    routeToFermentation,
    routeToPitchCalculator,
    routeToAnalysisHistory,
    routeToFermentationBatch,
    routeToFermentationTracking,
  };
};
